import React from "react";
import SearchBook from "../search-book";

function SearchSection() {
  return (
    <section id="counter">
      <div className="counter container">
        <SearchBook />
      </div>
    </section>
  );
}

export default SearchSection;
